import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const UserAuthContext = createContext(null);

export function UserAuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = unauth, object = authed
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/google/me");
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip the /me check.
        // AuthCallback will exchange the session_id and establish the session first.
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    function signInWithGoogle(returnTo) {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const path = returnTo || window.location.pathname + window.location.search;
        try {
            sessionStorage.setItem("sd_auth_return", path);
        } catch (_) {}
        const redirectUrl = window.location.origin + "/auth/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    }

    async function logout() {
        try {
            await api.post("/auth/google/logout");
        } catch (_) {}
        setUser(false);
    }

    return (
        <UserAuthContext.Provider
            value={{ user, loading, signInWithGoogle, logout, refresh: checkAuth, setUser }}
        >
            {children}
        </UserAuthContext.Provider>
    );
}

export function useUserAuth() {
    return useContext(UserAuthContext);
}
